import React from "react";
import PropTypes from "prop-types";
import { UiTitleContainer } from "./TitleContainer.style";
/**
 * 可設定標題跟內文的外框
 */

const TitleContainer = ({
  header,
  children
}) => {
  return /*#__PURE__*/React.createElement(UiTitleContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, header), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, children));
};

export default TitleContainer;
TitleContainer.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node
};